import {
  DocumentReference,
  ISoftDelete,
  ITimestampRange,
  Timestamp,
} from '@principle-theorem/shared';
import { IReportRun } from '../reports/report-run';

export enum MarketingCampaignRunStatus {
  Draft = 'draft',
  PendingPayment = 'pendingPayment',
  Pending = 'pending',
  Running = 'running',
  Complete = 'complete',
  Cancelled = 'cancelled',
  Skipped = 'skipped',
  Failed = 'failed',
}

export enum MarketingCampaignRunType {
  Automatic = 'automatic',
  Manual = 'manual',
}

export enum MarketingCampaignRunEnrollmentMethod {
  CustomReport = 'customReport',
  FileUpload = 'fileUpload',
}

export interface ICampaignRunEstimates {
  costPerEntry: number;
  newEntries: number;
  entriesThisRun?: number;
  estimatedCost: number;
}

export interface IMarketingCampaignRun extends ISoftDelete {
  status: MarketingCampaignRunStatus;
  estimates: ICampaignRunEstimates;
  type: MarketingCampaignRunType;
  enrolmentMethod?: MarketingCampaignRunEnrollmentMethod;
  enrolmentDate?: Timestamp;
  dateRange?: ITimestampRange;
  runAt?: Timestamp;
  cloudTaskId?: string;
  reportRunRef?: DocumentReference<IReportRun>;
  hasTrackedEnrolledEntries?: boolean;
}

export interface IMarketingCampaignRunCost {
  estimatedCost: number;
  estimatedCostRemaining: number;
  incurredCost: number;
}
